import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    component: () => import("./views/Home.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, ) {
    if (to.hash) {
        const targetElement = document.querySelector(to.hash);

        if (targetElement) {
            const offset = 100; // Смещение в пикселях
            const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;

            return window.scrollTo({
                top: elementPosition - offset,
                behavior: 'smooth',
            });
        }
    }
    return { top: 0 }; // Прокрутка к началу страницы по умолчанию
},
});

export default router;